import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["NotFoundLink"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/404/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["Switchers"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/footer/switchers.js");
;
import(/* webpackMode: "eager", webpackExports: ["LastUpdated"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/last-updated.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/locale-switch.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientNavbar"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/navbar/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNav","Sidebar"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/sidebar.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/theme-switch.js");
;
import(/* webpackMode: "eager", webpackExports: ["TOC"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/components/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeadingAnchor"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/mdx-components/heading-anchor.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/mdx-components/wrapper.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","useConfig"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/stores/config.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeConfigProvider","useThemeConfig"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/stores/theme-config.js");
;
import(/* webpackMode: "eager", webpackExports: ["TOCProvider","useTOC"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra-theme-docs/dist/stores/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/components/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["ImageZoom"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/components/image-zoom.js");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/components/select.js");
;
import(/* webpackMode: "eager", webpackExports: ["SkipNavLink"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/components/skip-nav/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","Tab"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/components/tabs/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["useCopy"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/hooks/use-copy.js");
;
import(/* webpackMode: "eager", webpackExports: ["useFSRoute"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/hooks/use-fs-route.js");
;
import(/* webpackMode: "eager", webpackExports: ["useHash"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/hooks/use-hash.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMounted"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/hooks/use-mounted.js");
;
import(/* webpackMode: "eager", webpackExports: ["Details"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/mdx-components/details.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyToClipboard"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/mdx-components/pre/copy-to-clipboard.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleWordWrapButton"] */ "/home/runner/work/DoenetML/DoenetML/node_modules/nextra/dist/client/mdx-components/pre/toggle-word-wrap-button.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/components/doenet.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/components/props-display.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/content/community/categories.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/content/community/findNotificationIcon.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/content/tutorials/media/CanvasHtmlEditor.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/content/tutorials/media/copyEmbedCode.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/content/tutorials/media/extensions.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/DoenetML/DoenetML/packages/docs-nextra/content/tutorials/media/shareSettings.png");
